(function () {
  'use strict';

  angular.module('app').component('serviceItemList', serviceItemList());

  function serviceItemList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowItem: '&',
        userLanguageCode: '<',
      },
      controller: ServiceItemListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/service-items/service-item-list/service-item-list.component.html',
    };
  }

  ServiceItemListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'ServiceItemService',
    'ServiceItemCostService',
  ];

  function ServiceItemListComponent(
    config,
    UtilService,
    AbilityService,
    ServiceItemService,
    ServiceItemCostService
  ) {
    var vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_serviceitem_accountadmin'),
      canUpdate: AbilityService.can('update_serviceitem_accountadmin'),
      canDestroy: AbilityService.can('destroy_serviceitem_accountadmin'),
    };

    vm.UtilService = new UtilService(vm);
    vm.dateDisplay = config.DATE_DISPLAY_SHORT;
    vm.filterCriteria = ServiceItemService.getFilterCriteria();

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.deleteItem = deleteItem;
    vm.changeItemStatus = changeItemStatus;

    vm.openServiceItemCostsModal = openServiceItemCostsModal;

    // Initializers
    getProductTypes();

    function getProductTypes() {
      var productTypes = angular.copy(vm.UtilService.getProductTypes());
      vm.productTypes = vm.UtilService.removeItemFromArray(productTypes, 'type', 'service_item');
    }

    function fetchResult() {
      vm.loadingItems = true;
      ServiceItemService.getServiceItems(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
        vm.showActions = false;
        vm.selectedAll = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.filterCriteria = ServiceItemService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item, mode) {
      vm.onShowItem({ item: item, mode: mode });
    }

    function deleteItem(item) {
      if (!vm.permissions.canDestroy) {
        return;
      }

      ServiceItemService.deleteServiceItem(item, fetchResult);
    }

    function changeItemStatus(item) {
      if (!vm.permissions.canUpdate) {
        return;
      }

      ServiceItemService.changeServiceItemStatus(item);
    }

    /*function onUpdateItems(action) {
        var successCallback = function () {
            vm.showActions = false;
            vm.selectedAll = false;

            if (action === 'destroy') { fetchResult(); }
        };

        ServiceItemService.updateServiceItems(action, vm.items, successCallback);
    }*/

    function openServiceItemCostsModal(serviceItem) {
      let successCallback = (dataObj) => {
        serviceItem.current_costs = {
          rates_today: dataObj.rates_today,
          rates_updated_until: dataObj.rates_updated_until,
          currency: dataObj.currency,
        };
      };

      ServiceItemCostService.openServiceItemCostsModal(
        serviceItem,
        {},
        'service-item',
        vm.userLanguageCode,
        successCallback
      );
    }
  }
})();
